export function initializeMultiple(dropify, defaultText) {
    dropify.on('change', function (e) {
        let files = e.target.files;
        let dropifyWrapper = $(e.target).closest('.dropify-wrapper');

        if (files.length > 1) {
            let fileCountMessage = files.length + ' files selected';
            dropifyWrapper.find('.dropify-message p').text(fileCountMessage);
            dropifyWrapper.find('.dropify-render').hide();

            // Dropify does some stuff so this works.
            setTimeout(function () {
                dropifyWrapper.find('.dropify-preview').hide();
            }, 300);
        } else {
            dropifyWrapper.find('.dropify-render, .dropify-preview').show();
        }
    });

    dropify.on('dropify.afterClear', function (e) {
        let dropifyWrapper = $(e.target).closest('.dropify-wrapper');

        dropifyWrapper.find('.dropify-render').show();
        dropifyWrapper.find('.dropify-message p').text(defaultText);
    });
}
